// store/modules/auth/index.js
import { apiClient } from '@/api'

export default {
  namespaced: true,
  state: () => ({
    setting: {}
  }),
  actions: {
    async getSettings({ commit }) {
      const res = await apiClient('settings.get')
      if (res?.settings) {
        commit('SET_SETTINGS', res?.settings)
      }
    },
    async updateSettings({ commit }, data) {
      const res = await apiClient('settings.update', data)
      if (res?.settings) {
        commit('SET_SETTINGS', res?.settings)
      }
    }
  },
  mutations: {
    SET_SETTINGS(state, data) {
      state.setting = data
    }
  }
}